"use client";

import React from "react";
import { RelatedLinks } from "@bfl-ui-toolkit/related-links";
import { IRelatedLinks } from "../../interfaces/IAMCContent.interface";
import { dataLayer, CombinedClevertapProps } from "@repo/analytics/data-layer-utils";
import { selectLoginStatus, useAppSelector } from "@repo/global-store";

interface AMCRelatedLinksProps {
  relatedLinksData: IRelatedLinks;
}

type RelatedLinkItem = {
  label?: string;
  url?: string;
};

type RelatedLinksGroup = Record<string, RelatedLinkItem>;

export const AMCRelatedLinks: React.FC<AMCRelatedLinksProps> = ({ relatedLinksData }) => {
  const { title, links } = relatedLinksData;

  const loginStatus = useAppSelector(selectLoginStatus);

  const tabsList = links?.map((group: RelatedLinksGroup) => {
    const formattedItems: Record<
      string,
      { ctaText: string; ctaLink: string; ctaInNewTab: string }
    > = {};

    Object.keys(group).forEach((key, index) => {
      const item = group[key];
      if (!item) return;

      formattedItems[`item${index + 1}`] = {
        ctaText: item.label ?? "",
        ctaLink: item.url ?? "",
        ctaInNewTab: "false",
      };
    });

    return formattedItems;
  });

  const handleRelatedLinksTrackEvent = (eventType: string) => {
    const payload = {
      component: "amc_related_links",
      element: "related_links_click",
      event: "click",
      event_type: eventType,
      destination_url: "NA",
      section_title: title,
      cta_text: "Related Links",
      product_name: "bajaj_mutual_fund",
      category_name: "mutual_fund",
      page_type: "pdp",
      component_position: "",
      component_id: "amc_related_links",
      customer_tag: loginStatus,
      is_loggedin: loginStatus,
    };

    dataLayer(loginStatus, payload, payload as unknown as CombinedClevertapProps);
  };

  const trackEvent = (payload?: { clickType?: string }) => {
    if (payload?.clickType) {
      handleRelatedLinksTrackEvent(payload.clickType);
    }
  };

  return (
    <div className="md:px-4 md:py-3" id="relatedLinks">
      <RelatedLinks
        content={{
          heading: title,
          tabsList,
        }}
        trackEvent={trackEvent}
      />
    </div>
  );
};

export default AMCRelatedLinks;
